export const routerArr =  (data) => {
  let routerMap = generator(data, '', '', [])
  routerMap.push({
    path: '/',
    name: 'Home',
    meta: {
      breadcrumb: ' / 首页',
      permissions: []
    },
    component: () => import(/* webpackChunkName: 'match' */'@/components/index/Home'),
  })
  let routers = [{
    path: '/',
    name: '',
    component: () => import(/* webpackChunkName: 'index' */ '@/components/Index'),
    children: routerMap
  }]
  console.log(routerMap)
  return routers
}

/**
 * 格式化 后端 结构信息并递归生成层级路由表
 *
 * @param data
 * @param parent
 * @returns {*}
 */
export const generator = (data, breadcrumb, menuName, routerMap) => {
  let brad = breadcrumb + (menuName === '' ? '' : ' / ' + menuName)
  data.map(item => {
    let permissions = []
    if (item.children) {
      item.children.map(child => {
        permissions.push(child.perms.replace(':{}',''))
        if (child.menuType === 3 && child.children) {
          child.children.map(childs => {
            permissions.push(childs.perms)
          })
        }
      })
    }
    // 页面级
    if (item.menuType === 2) {
      routerMap.push({
          path: item.path,
          name: item.menuKey,
          meta: {
              breadcrumb: brad + ' / ' + item.menuName,
              permissions: permissions
          },
          visible: item.visible,
          component: () => import(`@/components${item.component}`)
      })
    }
    if (item.children) {
      generator(item.children, brad, item.menuName, routerMap)
    }
  })
  return routerMap
}



// WEBPACK FOOTER //
// ./src/utils/routerUtil.js